import { Component, OnInit } from '@angular/core';
import { ProductCompetitionActiveResponse } from 'src/app/api/client/models';
import { CompetitionsService } from 'src/app/api/client/services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-competitions',
  templateUrl: './competitions.component.html',
  styleUrls: ['./competitions.component.scss'],
})
export class CompetitionsComponent implements OnInit {
  constructor(private api: CompetitionsService) {}

  ngOnInit(): void {
    this.ngFetch();
  }

  public activeCompetitions?: ProductCompetitionActiveResponse;

  async ngFetch() {
    this.activeCompetitions = await this.api
      .v1CompetitionsActivePost$Json({
        body: {
          productId: environment.productId,
        },
      })
      .toPromise();
  }

  decode(content: string) {
    return decodeURIComponent(content);
  }
}
